import { envConfig } from './envConfig';

export const isGCashEnv = envConfig.VITE_API_ENDPOINT.includes('gcash');
